<template>
  <div
    id="flow-wrapper"
    class="SB-border top"
    :style="flowTransformVars"
    @mousemove="onMouseMove"
    @mouseup="onMouseUp" >
    <div class="controls right">
      <!-- Recenter -->
      <div
        id="recenter"
        class="mr-2"
        @click="zoomReset" >
        <SBIcon
          class="m-2"
          :icon="SBIconList.RECENTER"
          :color="SBColors.blackLight"
          :size="12"
          :rotate="90"
          pointer />
      </div>
      <b-popover
        target="recenter"
        triggers="hover"
        placement="left"
        :delay="{ show: 50, hide: 0 }"
        custom-class="basic-popover">
        Recenter
      </b-popover>

      <!-- Full screen -->
      <div
        id="full-window"
        @click="expand">
        <SBIcon
          class="m-2"
          :icon="fullWindow ? SBIconList.SMALL_WINDOW : SBIconList.FULL_WINDOW"
          :color="SBColors.blackLight"
          :size="12"
          :rotate="90"
          pointer />
      </div>
      <b-popover
        target="full-window"
        triggers="hover"
        placement="left"
        :delay="{ show: 50, hide: 0 }"
        custom-class="basic-popover">
        {{ fullWindow ? 'Exit' : 'Fullscreen' }}
      </b-popover>
    </div>
    <div class="controls left">
      <!-- <div @click="zoomIn">
        <SBIcon
          class="m-2"
          :icon="SBIconList.MAGNIFIER"
          :color="SBColors.blackLight"
          :size="12"
          :rotate="90"
          pointer />
      </div>
      <div @click="zoomOut">
        <SBIcon
          class="m-2"
          :icon="SBIconList.MAGNIFIER"
          :color="SBColors.blackLight"
          :size="12"
          :rotate="90"
          pointer />
      </div> -->

      <div
        v-if="currentOrganisation.businesses.length > 1"
        class="number-info flex flex-center-all mr-2" >
        <span>{{ business.emoji }}</span>
        <p class="ellipsis">{{ business.name }}</p>
      </div>
    </div>
    <div
      id="flow-container"
      :style="{ 'min-width': minWidth }"
      :class="{ busy: updatingFlow }" >
      <div class="number-flow-tree">
        <ul>
          <FlowNode
            :node="workingFlow"
            :scale="scale"
            :auto-scroll-offset="offsetTrigger"
            :auto-scroll-active="autoScrollActive"
            :positions="positions"
            :update-position="updatePosition"
            :wrapper-offset="{ top: element ? Number.parseInt(element.style.top.replace('px', ''), 10) || 0 : 0, left: element ? Number.parseInt(element.style.left.replace('px', ''), 10) || 0 : 0 }" />
        </ul>
      </div>
    </div>

    <!-- <div style="position: absolute; top: 0; left: 0; display: absolute;">
      <p>Mouse x: {{ positions.x }}</p>
      <p>Mouse y: {{ positions.y }}</p>
      <p>FLOW x: {{ positions.wrapperX }}</p>
      <p>FLOW y: {{ positions.wrapperY }}</p>
      <p>FLOW width: {{ positions.wrapperWidth }}</p>
      <p>FLOW height: {{ positions.wrapperHeight }}</p>
      <p>Dragover: {{ draggedOverKey || '-' }}</p>
    </div> -->
  </div>
</template>

<!-- REMOVE all logs -->

<script>
import { mapActions, mapGetters } from 'vuex';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import FlowNode from './FlowNode';

export default {
  name: 'FlowTree',
  components: {
    FlowNode,
    SBIcon,
  },
  props: {
    flow: {
      type: Object,
      required: true,
      default: () => {},
    },
    preventKeys: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      scale: 1,
      minScale: 0.4,
      scaleStep: 0.1,
      itemCount: 0,
      // containerBoundingRect: null,
      leftInterval: null,
      rightInterval: null,
      upInterval: null,
      downInterval: null,
      element: null,
      updatePosition: 0,
      offsetTrigger: {
        left: 0,
        up: 0,
      },
      positions: {
        x: 0,
        y: 0,
        wrapperX: 0,
        wrapperY: 0,
        wrapperWidth: 0,
        wrapperHeight: 0,
      },
      mouseCurrentX: 0,
      mouseCurrentY: 0,
      workingFlow: {},
      workingFlowBusy: false,
      workingFlowTimer: null,
      onePixelPerNSeconds: 5,
      movePerNPixels: 5,
      minWidth: 0,
      itemsRects: null,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      draggedOverKey: 'helpers/draggedOverKey',
      fullWindow: 'system/fullWindow',
      currentOrganisation: 'organisation/currentOrganisation',
      updatingFlow: 'flows/updatingFlow',
    }),
    autoScrollActive() {
      return !!this.leftInterval || !!this.rightInterval || !!this.upInterval || !!this.downInterval;
    },
    flowTransformVars() {
      return {
        '--zoomLevel': this.scale,
      };
    },
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.numberId);
    },
  },
  watch: {
    autoScrollActive() {
      if (!this.autoScrollActive) {
        this.getEveryItemRect();
      }
    },
    draggedOverKey() {
      this.getEveryItemRect();
    },
    flow: {
      handler() {
        this.workingFlow = JSON.parse(JSON.stringify(this.flow));
      },
      immediate: true,
    },
    workingFlow: {
      handler() {
        if (this.workingFlowBusy) return;
        this.workingFlowBusy = true;
        this.processItems(this.workingFlow);
        setTimeout(() => {
          this.minWidth = (this.element.offsetWidth > this.minWidth) ? `${this.element.offsetWidth}px` : this.minWidth;
        }, 0);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.dragElement = document.getElementById('flow-wrapper');
    this.dragElement.onmousedown = this.dragMouseDown;
    // Zoom on mouse wheel
    // this.dragElement.addEventListener('wheel', this.zoom, { passive: false });
    // Move on mouse wheel
    this.dragElement.addEventListener('wheel', this.moveContainer, { passive: false });
    // this.containerBoundingRect = this.element.getBoundingClientRect();
    // Prevent right click
    this.dragElement.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });

    this.element = document.getElementById('flow-container');

    // console.dir(document.getElementById('flow-wrapper'));
    // const flowWrapperEl = document.getElementById('flow-wrapper');
    this.setWrapperPositions();

    this.$eventBus.$on('flow-drop', this.onFlowDrop);
    this.$eventBus.$on('flow-remove', this.onFlowRemove);

    // MOVE THIS TO WATCHER WHEN LOADING FLOW FROM API IS FINISHED
    setTimeout(() => {
      this.centerFlow();
      this.getEveryItemRect();
    }, 0);

    window.addEventListener('resize', () => {
      // console.log('resize', event);
      // const flowWrapperEl = document.getElementById('flow-wrapper');
      this.setWrapperPositions();
    });

    window.addEventListener('mousemove', (event) => {
      this.positions = {
        ...this.positions,
        x: event.clientX,
        y: event.clientY,
      };
    });

    window.addEventListener('mouseup', () => {
      this.onMouseUp();
    });

    window.addEventListener('keydown', this.handleKeyDown);

    this.$eventBus.$on('flow-drag-start', this.dragStart);
    this.$eventBus.$on('flow-drag-end', this.dragEnd);
    this.$eventBus.$on('flow-dragging', this.draggingItem);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
    this.setFullWindow(false);
  },
  methods: {
    ...mapActions({
      setDraggedOverKey: 'helpers/draggedOverKey',
      setFullWindow: 'system/setFullWindow',
      removeFlowBlock: 'flows/removeFlowBlock',
      updateFlowPositions: 'flows/updateFlowPositions',
    }),
    centerFlow() {
      let direction = 1;
      if (this.positions.wrapperWidth < this.element.offsetWidth) {
        direction = -1;
      }
      this.element.style.left = `${Math.abs(this.element.offsetWidth - this.positions.wrapperWidth) / 2 * direction}px`;
      this.element.style.top = '35px';
      this.dragElement.style.backgroundPosition = `${this.element.style.left} ${this.element.style.top}`;
    },
    dragStart() {
      this.dragElement.classList.add('dragging');
      this.getEveryItemRect();
    },
    dragEnd() {
      this.dragElement.classList.remove('dragging');
    },
    setWrapperPositions() {
      // We need to wait for the element to be rendered before we can get it's position and it renders after the next tick since we are updating vuex state
      setTimeout(() => {
        this.positions.wrapperX = this.dragElement.offsetLeft;
        this.positions.wrapperY = this.dragElement.offsetTop;
        this.positions.wrapperWidth = this.dragElement.offsetWidth;
        this.positions.wrapperHeight = this.dragElement.offsetHeight;
      }, 0);
    },
    handleKeyDown(event) {
      if (this.preventKeys) return;
      // const by which we move the element which is bigger if the shift key is pressed with the arrow keys
      const moveBy = event.shiftKey ? 50 : 10;
      switch (event.keyCode) {
        // UP arrow
        case 38:
          event.preventDefault();
          this.element.style.top = `${this.element.offsetTop - moveBy}px`;
          break;
        // DOWN arrow
        case 40:
          event.preventDefault();
          this.element.style.top = `${this.element.offsetTop + moveBy}px`;
          break;
        // LEFT arrow
        case 37:
          event.preventDefault();
          this.element.style.left = `${this.element.offsetLeft - moveBy}px`;
          break;
        // RIGHT arrow
        case 39:
          event.preventDefault();
          this.element.style.left = `${this.element.offsetLeft + moveBy}px`;
          break;
        default:
          break;
      }
      this.dragElement.style.backgroundPosition = `${this.element.style.left} ${this.element.style.top}`;
    },
    onMouseUp() {
      this.onMouseLeave();
    },
    /**
     * Method is executed when node is dropped on the flow and updates the flow tree based on the received data.
     * @param {*} dropData Data dropped on top of another flow node.
     */
    onFlowDrop(dropData) {
      this.dragElement.classList.remove('dragging');
      if (!dropData.target) return;
      if ((this.workingFlow.position === dropData.dropped.position) && this.workingFlow.children.length > 1) return; // first node with multiple children can't be moved
      let flowDuplicate = JSON.parse(JSON.stringify(this.workingFlow));

      // 1. delete from previous position
      flowDuplicate = this.deleteNode(flowDuplicate, dropData.dropped.position);

      // 2. add to new position
      flowDuplicate = this.addNode(flowDuplicate, dropData.dropped, dropData.target, dropData.above);

      this.workingFlow = { ...flowDuplicate };

      this.$nextTick(() => {
        this.updateFlowPositions({
          above: dropData.above,
          target: this.itemsRects[dropData.target].id,
          dropped: dropData.dropped.id,
        });
      });
    },
    onFlowRemove(options) {
      this.dragElement.classList.remove('dragging');

      this.removeFlowBlock(options)
        .then((response) => {
          if (response.status === 200) {
            this.$confirmPluginModal.close();
          } else {
            // TODO add toast error
          }
        })
        .catch((error) => {
          // TODO add toast error
        });
    },
    /**
     * Add node into flow tree.
     * @param {Object} flowTree Current nodes tree.
     * @param {Object} newNode New node that needs to be inserted.
     * @param {number} target Target position where new node needs to be inserted.
     * @param {boolean} above Flag which defines if new node needs to be inserted above or below target position.
     * @returns {Object} Updated flow tree.
     */
    addNode(flowTree, newNode, target, above = false) {
      if (flowTree.position === target) {
        if (above) {
          newNode.children = [flowTree];
          return newNode;
        }
        newNode.children = flowTree.children ? JSON.parse(JSON.stringify(flowTree.children)) : [];
        flowTree.children = [newNode];
        return flowTree;
      }
      if (!flowTree.children || !flowTree.children.length) {
        return flowTree;
      }

      const findInHere = this.getTargetSection(flowTree.children, target);
      const result = this.addNode(findInHere, newNode, target, above);
      flowTree.children = this.swapPositions(flowTree.children, findInHere.position, result);

      return flowTree;
    },
    /**
     * Delete node from flow tree. First node with multiple children can't be removed. It's the root node.
     * @param {Object} flowTree Current nodes tree.
     * @param {number} target Target position where new node needs to be inserted.
     * @param {Object} previousNode Parent of the current node. Used to prevent deleting first node.
     * @returns {Object} Updated flow tree.
     */
    deleteNode(flowTree, target, previousNode = null, removeChildren = false) {
      if (previousNode && flowTree.position === target) {
        if (!flowTree.children || !flowTree.children.length) {
          return [];
        }

        if (removeChildren) {
          return [];
        }

        return [...flowTree.children];
      }
      if (!previousNode && flowTree.children && (flowTree.children.length === 1) && (flowTree.position === target)) {
        return flowTree.children[0];
      }
      if (!flowTree.children || !flowTree.children.length) {
        return [];
      }

      const findInHere = this.getTargetSection(flowTree.children, target);
      const result = this.deleteNode(findInHere, target, flowTree, removeChildren);
      flowTree.children = this.swapPositions(flowTree.children, findInHere.position, result);

      return flowTree;
    },
    /**
     * Narrows down the section where target node is by principals of binary tree search.
     * @param {Array} flowTree Flow tree to search in.
     * @param {number} target Target position where new node needs to be inserted.
     * @returns {Object} Node tree where the target node is.
     */
    getTargetSection(nodes, target) {
      const sortedChildren = nodes.slice().sort((a, b) => a.position - b.position);
      const higherValueIndex = sortedChildren.findIndex(n => n.position > target);
      if (higherValueIndex > 0) {
        return sortedChildren[higherValueIndex - 1];
      }
      return sortedChildren.slice(-1)[0];
    },
    /**
     * Swaps positions of two nodes in the flow tree.
     * @param {Array} nodes Nodes to search in.
     * @param {number} position Position of the node that needs to be swapped.
     * @param {Object|Array} newNode New node that needs to be inserted or list of nodes to be iserted.
     * @returns {Array} Updated array of nodes.
     */
    swapPositions(nodes, position, newNode) {
      const swapPosition = nodes.findIndex(n => n.position === position);
      if (Array.isArray(newNode)) {
        nodes.splice(swapPosition, 1, ...newNode);
      } else {
        nodes.splice(swapPosition, 1, newNode);
      }
      return nodes;
    },
    /**
     * Finds a target node in the flow tree.
     * @param {Object} flowTree Flow tree to search in.
     * @param {number} target Target position of the node.
     * @returns {Object} Target node.
     */
    findNode(flowTree, target) {
      if (flowTree.position === target) {
        return flowTree;
      }
      if (!flowTree.children || !flowTree.children.length) {
        return null;
      }

      const findInHere = this.getTargetSection(flowTree.children, target);
      return this.findNode(findInHere, target, flowTree);
    },
    onMouseMove(event) {
      const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
      if (!SBdragging || !SBdragging.active) {
        // console.log('not dragging');
        return;
      } else {
        // console.log('dragging');
      }
      // console.log(event);
      // console.log(event.pageX, event.pageY, ':::', event.pageX - Number.parseInt(this.dragElement.offsetLeft, 10));
      // console.dir(this.dragElement);

      // AUTO drag left
      if (event.pageX - this.dragElement.offsetLeft < 100) {
        // console.log('trigger left interval', this.leftInterval);
        if (!this.leftInterval) {
          this.leftInterval = setInterval(() => {
            // console.log('left interval');
            this.element.style.left = `${this.element.offsetLeft + this.movePerNPixels}px`;
            this.offsetTrigger = {
              left: this.movePerNPixels * -1,
              up: 0,
            };
          }, this.onePixelPerNSeconds);
        }
      } else {
        // console.log('clear left interval');
        clearInterval(this.leftInterval);
        this.leftInterval = null;
      }

      // AUTO drag right
      if ((this.dragElement.offsetLeft + this.dragElement.offsetWidth) - event.pageX < 100) {
        // console.log('trigger left interval', this.rightInterval);
        if (!this.rightInterval) {
          this.rightInterval = setInterval(() => {
            // console.log('right interval');
            this.element.style.left = `${this.element.offsetLeft - this.movePerNPixels}px`;
            this.offsetTrigger = {
              left: this.movePerNPixels,
              up: 0,
            };
          }, this.onePixelPerNSeconds);
        }
      } else {
        // console.log('clear left interval');
        clearInterval(this.rightInterval);
        this.rightInterval = null;
      }

      // AUTO drag up
      if (event.pageY - this.dragElement.offsetTop < 100) {
        // console.log('trigger top interval', this.upInterval);
        if (!this.upInterval) {
          this.upInterval = setInterval(() => {
            // console.log('top interval');
            this.element.style.top = `${this.element.offsetTop + this.movePerNPixels}px`;
            this.offsetTrigger = {
              left: 0,
              up: this.movePerNPixels * -1,
            };
          }, this.onePixelPerNSeconds);
        }
      } else {
        // console.log('clear top interval');
        clearInterval(this.upInterval);
        this.upInterval = null;
      }

      // AUTO drag down
      if ((this.dragElement.offsetTop + this.dragElement.offsetHeight) - event.pageY < 100) {
        // console.log('trigger left interval', this.downInterval);
        if (!this.downInterval) {
          this.downInterval = setInterval(() => {
            // console.log('down interval');
            this.element.style.top = `${this.element.offsetTop - this.movePerNPixels}px`;
            this.offsetTrigger = {
              left: 0,
              up: this.movePerNPixels,
            };
          }, this.onePixelPerNSeconds);
        }
      } else {
        // console.log('clear left interval');
        clearInterval(this.downInterval);
        this.downInterval = null;
      }
      // console.log(event);
      // console.log(event.pageX, event.pageY, event.pageX - this.containerBoundingRect.left, event.pageY - this.containerBoundingRect.top);
      // this.element.style.transformOrigin = `${event.pageX - this.containerBoundingRect.left}px ${event.pageY - this.containerBoundingRect.top}px`;
      // transform-origin: 0 0;
      this.dragElement.style.backgroundPosition = `${this.element.style.left} ${this.element.style.top}`;
    },
    onMouseLeave() {
      // console.log('clear all intervals');
      clearInterval(this.leftInterval);
      clearInterval(this.rightInterval);
      clearInterval(this.upInterval);
      clearInterval(this.downInterval);
      this.leftInterval = null;
      this.rightInterval = null;
      this.upInterval = null;
      this.downInterval = null;
    },
    processItems(node = {}, previousNode = {}) {
      clearTimeout(this.workingFlowTimer);
      this.workingFlowTimer = setTimeout(() => {
        this.workingFlowBusy = false;
      }, 10);
      // console.log('--- ', node, previousNode, this.emptyObject(previousNode));

      // POSITION
      if (node.label) {
        this.itemCount++;
        node.position = this.itemCount;
      }

      // MOVABLE
      if (
        this.emptyObject(previousNode)
        // ||
        // (node.children && node.children.length > 1) ||
        // ((!node.children || !node.children.length) && previousNode.movable === false)
      ) {
        // node.movable = false;
      }

      // RECURSIVE
      if (node.children && node.children.length) {
        node.children.forEach(n => this.processItems(n, node));
      }
    },
    dragMouseDown(e) {
      // e.preventDefault();
      // Get the mouse mouse position at startup
      this.mouseCurrentX = e.clientX;
      this.mouseCurrentY = e.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag(e) {
      e.preventDefault();
      // Calculate the mouse movement
      const mouseMoveX = this.mouseCurrentX - e.clientX;
      const mouseMoveY = this.mouseCurrentY - e.clientY;
      this.mouseCurrentX = e.clientX;
      this.mouseCurrentY = e.clientY;
      // Set the element's new position
      this.element.style.top = `${this.element.offsetTop - mouseMoveY}px`;
      this.element.style.left = `${this.element.offsetLeft - mouseMoveX}px`;
      this.dragElement.style.backgroundPosition = `${this.element.style.left} ${this.element.style.top}`;
    },
    closeDragElement() {
      // Stop moving when mouse button is released
      document.onmouseup = null;
      document.onmousemove = null;
    },
    zoomIn() {
      // console.log('click');
      this.scale += this.scaleStep;
      this.scale = Math.min(this.scale + this.scaleStep, 10);
    },
    zoomOut() {
      this.scale = Math.max(this.minScale, this.scale - this.scaleStep);
    },
    zoomReset() {
      this.scale = 1;
      this.centerFlow();
    },
    zoom(event) {
      // console.log('wheel');
      event.preventDefault();

      // console.log(event);
      // console.log(event.pageX, event.pageY, event.pageX - this.containerBoundingRect.left, event.pageY - this.containerBoundingRect.top);
      // this.element.style.transformOrigin = `${event.pageX - this.containerBoundingRect.left}px ${event.pageY - this.containerBoundingRect.top}px`;

      this.scale += event.deltaY * -0.001;
      // Restrict scale
      this.scale = Math.min(Math.max(this.minScale, this.scale), 10);
      // Apply scale transform
      // el.style.transform = `scale(${scale})`;
    },
    expand() {
      if (!this.fullWindow) {
        this.offsetOnFullWindow();
      } else {
        this.offsetOnFullWindow(true);
      }
      this.setFullWindow(!this.fullWindow);
      this.setWrapperPositions();
    },
    offsetOnFullWindow(delay = false) {
      const target = document.getElementsByClassName('flow-manage');
      let offset = 0;
      if (!delay && target && target.length) {
        offset = Math.ceil(target[0].offsetLeft / 2);
        this.element.style.left = `${this.element.offsetLeft + offset}px`;
      } else if (delay && target && target.length) {
        setTimeout(() => {
          offset = Math.floor(-1 * (target[0].offsetLeft / 2));
          this.element.style.left = `${this.element.offsetLeft + offset}px`;
        }, 0);
      }
    },
    moveContainer(e) {
      this.element.style.top = `${this.element.offsetTop + e.wheelDeltaY}px`;
      this.element.style.left = `${this.element.offsetLeft + e.wheelDeltaX}px`;
      this.dragElement.style.backgroundPosition = `${this.element.style.left} ${this.element.style.top}`;
    },
    /**
     * Get positions of every tree item
     */
    getEveryItemRect(delay = 0) {
      setTimeout(() => {
        this.items = document.querySelectorAll('.number-flow-tree .item-wrapper');
        this.itemsRects = {};
        this.items.forEach((item) => {
          const itemRect = item.getBoundingClientRect();
          this.itemsRects[item.dataset.target] = {
            top: itemRect.top,
            bottom: itemRect.bottom,
            left: itemRect.left,
            right: itemRect.right,
            height: itemRect.height,
            width: itemRect.width,
            id: item.id,
          };
        });
      }, delay);
    },
    draggingItem(position) {
      const dragEl = document.getElementById(`drag-item-${position}`);
      const boundingRectData = dragEl.getBoundingClientRect();
      const dragDirection = localStorage.getItem('SBDragDirection');

      let foundTarget = false;
      Object.keys(this.itemsRects).some((irKey) => {
        if (Number.parseInt(irKey, 10) === position) {
          // Skip if checking the dragging item
          return false;
        }
        // const offset = irKey === this.draggedOverKey ? JSON.parse(localStorage.getItem('SBdragging')).height + (50 * this.scale) : 0;
        const offset = 0;
        // console.log(
        //   'IRKEY:', irKey,
        //   this.itemsRects[irKey].bottom, '+',
        //   offset, '>',
        //   boundingRectData.bottom, '&&',
        //   this.itemsRects[irKey].top, '<', boundingRectData.bottom, '=',
        //   ((this.itemsRects[irKey].bottom + offset) > boundingRectData.bottom && this.itemsRects[irKey].top < boundingRectData.bottom)
        // );
        if (
          (
            dragDirection === 'UP' &&
            (
              ((this.itemsRects[irKey].bottom + offset) > boundingRectData.top && this.itemsRects[irKey].top < boundingRectData.top) ||
              (this.itemsRects[irKey].top < boundingRectData.bottom && (this.itemsRects[irKey].bottom + offset) > boundingRectData.bottom)
            ) &&
            (
              (this.itemsRects[irKey].right > (boundingRectData.left + (boundingRectData.width / 2)) && this.itemsRects[irKey].left < (boundingRectData.left + (boundingRectData.width / 2))) ||
              (this.itemsRects[irKey].left < (boundingRectData.right - (boundingRectData.width / 2)) && this.itemsRects[irKey].right > (boundingRectData.right - (boundingRectData.width / 2)))
            )
          ) ||
          (
            dragDirection === 'DOWN' &&
            (
              ((this.itemsRects[irKey].bottom + offset) > boundingRectData.bottom && this.itemsRects[irKey].top < boundingRectData.bottom)
            ) &&
            (
              (this.itemsRects[irKey].right > (boundingRectData.left + (boundingRectData.width / 2)) && this.itemsRects[irKey].left < (boundingRectData.left + (boundingRectData.width / 2))) ||
              (this.itemsRects[irKey].left < (boundingRectData.right - (boundingRectData.width / 2)) && this.itemsRects[irKey].right > (boundingRectData.right - (boundingRectData.width / 2)))
            )
          )
        ) {
          if (irKey === this.draggedOverKey) {
            // const height = (this.itemsRects[irKey].bottom - this.itemsRects[irKey].top) + JSON.parse(localStorage.getItem('SBdragging')).height + (50 * this.scale);
            // if ((boundingRectData.top - this.itemsRects[irKey].top) > (this.itemsRects[irKey].bottom - this.itemsRects[irKey].top)) {
            //   localStorage.setItem('SBdragoverLocation', 'after');
            // } else {
            //   localStorage.setItem('SBdragoverLocation', 'before');
            // }

            if (dragDirection === 'UP') {
              if ((boundingRectData.top - this.itemsRects[irKey].top) > (this.itemsRects[irKey].bottom - this.itemsRects[irKey].top)) {
                localStorage.setItem('SBdragoverLocation', 'after');
              } else {
                localStorage.setItem('SBdragoverLocation', 'before');
              }
            } else {
              if ((this.itemsRects[irKey].top + boundingRectData.height + 50) < boundingRectData.bottom) {
                localStorage.setItem('SBdragoverLocation', 'after');
              } else {
                localStorage.setItem('SBdragoverLocation', 'before');
              }
            }
            this.updatePosition++;
          }

          this.setDraggedOverKey(irKey);
          foundTarget = true;
          return true;
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss">
#flow-wrapper {
  height: 100%;
  // border: 1px solid red;
  overflow: hidden;
  position: relative;
  margin-bottom: 0px;
  background-color: #FBFCFD;
  // background-image: url('~@/assets/img/SB-Images/dot-background.svg');
  background-image: url('~@/assets/img/SB-Images/dot-background2.svg');
  background-repeat: repeat;
  background-size: 28px;
  background-position: var(--backgroundX) var(--backgroundY);

  &.dragging * {
    cursor: grabbing !important;
  }

  .controls {
    position: absolute;
    top: 15px;
    z-index: 10;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &.left {
      left: 15px;
    }

    &.right {
      right: 15px;
    }

    & > div {
      background-color: $white;
      box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      // border-top: solid 1px $greyBorder;
      // border-bottom: solid 1px $greyBorder;
      border: solid 1px $greyBorder;
        border-radius: 6px;

      &:hover {
        box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.3);

        p {
          color: $blackPrimary;
        }

        .icon.mask {
          background-color: $blackPrimary !important;
        }
      }

      // USED with border-top and border-bottom above ig we want to group the items.
      // &:first-of-type {
      //   border: solid 1px $greyBorder;
      //   border-radius: 6px 0 0 6px;
      // }

      // &:last-of-type {
      //   border: solid 1px $greyBorder;
      //   border-radius: 0 6px 6px 0;
      // }

      // &:only-of-type {
      //   border-radius: 6px;
      // }

      .sb-icon {
        margin: 8px 5px 8px 10px;
      }

      p {
        font-size: 12px;
        font-weight: 500;
        color: $blackPrimary;
        margin-right: 10px;
        font-size: 14px;
        color: $blackLight;
      }
    }

    .number-info {
      cursor: default;
      max-width: 190px;
      padding: 5px 8px 6px;
      font-size: 12px;
      font-weight: 500;

      p {
        margin-right: 0 !important;
        margin-left: 6px !important;
      }

      &:hover {
        box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1);
        p {
          color: $blackLight;
        }
      }
    }
  }

  #flow-container {
    position: absolute;
    z-index: 9;
    white-space: nowrap;
    transform: scale(var(--zoomLevel));
    // top: 35px;
    // transform-origin: 900px 500px;    // find middle and set it

    // .item {
    //   width: 353px;
    //   min-height: 63px;
    //   padding: 12px 12px 11px 12px;
    //   border-radius: 18px;
    //   box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
    //   border: solid 1px $greyBorder;
    //   background-color: $white;

    //   .logo-wrapper {
    //     width: 40px;
    //     height: 40px;
    //     padding: 10px;
    //     margin-right: 7px;
    //     border-radius: 12px;
    //     box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.16);
    //     border: solid 1px $greyBorder;

    //     .image-wrapper {
    //       width: 100%;
    //       height: 100%;
    //       background-image: var(--background-image);
    //       background-size: contain;
    //       background-repeat: no-repeat;
    //       background-position: center;
    //     }
    //   }

    //   h3 {
    //     font-size: 12px;
    //     font-weight: 400;
    //     color: #54626c;
    //   }

    //   p {
    //     font-size: 14px;
    //     font-weight: 500;
    //     color: $blackPrimary;
    //   }
    // }

    &.busy {
      .add, .right-plus, .left-plus {
        background-color: #F8FAFB;
        color: #9EAFB5;
        cursor: default;

        &:hover {
          box-shadow: none !important;
        }
      }
    }
  }

  // Mark all the children paths with red when remove button is hovered
  li.mark-red {
    :before, :after {
      border-color: #E38888 !important;
    }
  }
}

.number-flow-tree {
      width: 100%;
      height: auto;
      text-align: center;
    }
    .number-flow-tree ul:not(.drag-active) {
      // border: 1px dashed lightseagreen;
      padding-top: 50px;
      position: relative;
      // transition: .5s;
    }
    .number-flow-tree > ul {
      padding-top: 0 !important;
    }
    // First element after the frequency
    .number-flow-tree > ul > li > ul {
      padding-top: 24px !important;
    }
    .number-flow-tree .split-wrapper {
      padding: 12px;
      z-index: 9;
      border-radius: 18px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
      border: solid 1px $greyBorder;
      background-color: $white;
    }
    .number-flow-tree ul.split-mode {
      padding-top: 0px;
      margin-top: -33px;

      &:before {
        display: none;
      }

      &:not(.maxed-out) {
        & > li {
          &:first-child {
            &:before {
              border-top: 1px dashed $greyBorder;
              width: 190px;
              transform: translateX(14px);
            }

            > .left-plus {
              display: block !important;
              top: -9px;
              left: calc(50% - 176px);
              cursor: pointer;
            }
          }

          &:last-child {
            &:after {
              border-top: 1px dashed $greyBorder;
              width: 190px;
              transform: translateX(-14px);
            }

            > .right-plus {
              display: block !important;
              top: -9px;
              right: calc(50% - 176px);
              cursor: pointer;
            }
          }

          .right-plus, .left-plus {
            z-index: 9;
            border-radius: 18px;
            // box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
            border: solid 1px $greyBorder;
            background-color: $white;
            width: 20px;
            height: 20px;

            &:hover {
              background-color: #F2FEFF;
              box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.16);
            }
          }
        }
      }

      & > li {
        padding-top: 80px;

        &:after {
          height: 80px;
        }

        &:first-child {
          &:after {
            height: 80px;
          }
        }

        &:last-child {
          &:before {
            height: 80px;
          }
        }
      }
    }
    .number-flow-tree li {
      display: inline-table;
      text-align: center;
      list-style-type: none;
      position: relative;
      padding-bottom: 10px;
      // transition: .5s;
    }
    .number-flow-tree li::before, .number-flow-tree li::after {
      content: '';
      position: absolute;
      top: 0;
      right: 50%;
      border-top: 1px solid $greyBorder;
      width: 51%;
      height: 10px;
    }
    .number-flow-tree li::after {
      right: auto;
      left: 50%;
      border-left: 1px solid $greyBorder;
    }
    .number-flow-tree li:only-child::after, .number-flow-tree li:only-child::before {
      display: none;
    }
    .number-flow-tree li:only-child {
      padding-top: 0;
    }
    .number-flow-tree li:first-child::before, .number-flow-tree li:last-child::after {
      border: 0 none;
    }
    .number-flow-tree li:last-child::before {
      border-right: 1px solid $greyBorder;
      border-radius: 0 20px 0 0;
      -webkit-border-radius: 0 20px 0 0;
      -moz-border-radius: 0 20px 0 0;
    }
    .number-flow-tree li:first-child::after {
      border-radius: 20px 0 0 0;
      -webkit-border-radius: 20px 0 0 0;
      -moz-border-radius: 20px 0 0 0;
    }
    .number-flow-tree ul li {
      vertical-align: text-top;
    }
    .number-flow-tree ul ul:not(.drag-active):before,
    .number-flow-tree ul ul.self-temp:before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      border-left: 1px solid $greyBorder;
      width: 0;
      height: 50px;
    }
    // NOVO
    .number-flow-tree ul ul::after {
      // content: '+-';
      // position: absolute;
      // top: 15px;
      // left: calc(50% - 10px);
      // border: 1px solid #ccc;
      // border-radius: 10px;
      // width: 20px;
      // height: 20px;
      // background: $white;
      // cursor: pointer;
    }
    // NOVO
    // .number-flow-tree ul ul li span.add {
    //   position: absolute;
    //   // top: calc(66px + 15px);
    //   top: 0px;
    //   left: calc(50% - 10px);
    //   border: 1px solid #ccc;
    //   border-radius: 10px;
    //   width: 20px;
    //   height: 20px;
    //   background: $white;
    //   cursor: pointer;
    // }
    li:only-child {
      // top: 10px;
      // border: 1px solid red;

      // span.add {
      //   top: 10px !important;
      // }
    }
    // NOVO END
    .number-flow-tree li a {
      // width: 353px;
      // border: 1px solid #ccc;
      // padding: 10px;
      // display: inline-grid;
      // border-radius: 5px;
      // text-decoration-line: none;
      // border-radius: 5px;
      // transition: .5s;
    }
    .number-flow-tree li a img {
      // width: 50px;
      // height: 50px;
      // margin-bottom: 10px !important;
      // border-radius: 100px;
      // margin: auto;
    }
    .number-flow-tree li a span {
      // border: 1px solid #ccc;
      // border-radius: 5px;
      // color: #666;
      // padding: 8px;
      // font-size: 12px;
      // text-transform: uppercase;
      // letter-spacing: 1px;
      // font-weight: 500;
    }
    /*Hover-Section*/
    .number-flow-tree li .item:hover, .number-flow-tree li .item:hover i, .number-flow-tree li .item:hover span, .number-flow-tree li .item:hover+ul li .item {
      // background: #c8e4f8;
      // color: #000;
      // border: 1px solid #94a0b4;
    }
    .number-flow-tree li a:hover+ul li::after, .number-flow-tree li a:hover+ul li::before, .number-flow-tree li a:hover+ul::before, .number-flow-tree li a:hover+ul ul::before {
      // border-color: #94a0b4;
    }
</style>
